/** Shared Help & support chips/links for Talkie fallbacks (pure). */

import { SlateChip, slateChipLabel } from './slate.types';

export const SLATE_HELP_PROMPT = 'Help and support';

export const SLATE_FEEDBACK_PROMPTS = [
    'Data looks wrong — Help and support',
    'I do not understand — Help and support',
] as const;

/** Append support escape hatch without duplicating. */
export function withHelpChips(chips: Array<SlateChip> | undefined): Array<SlateChip> {
    const base = [...(chips || [])];
    if (
        !base.some((c) =>
            /help\s+and\s+support|help\s*&\s*support/i.test(slateChipLabel(c))
        )
    ) {
        base.push(SLATE_HELP_PROMPT);
    }
    return base;
}

/** Clarify / error cards: wrong-data + confusion chips + Help. */
export function withSupportEscapeChips(
    chips: Array<SlateChip> | undefined
): Array<SlateChip> {
    const base = withHelpChips(chips);
    for (const p of SLATE_FEEDBACK_PROMPTS) {
        if (!base.some((c) => slateChipLabel(c) === p)) base.push(p);
    }
    return base;
}

export function isFeedbackOrConfusionAsk(text: string): boolean {
    const t = text.toLowerCase().trim();
    if (!t) return false;
    return (
        /\b(?:wrong|incorrect|not\s+correct|inaccurate|bad\s+data|data\s+(?:is\s+)?wrong)\b/.test(
            t
        ) ||
        /\b(?:don'?t|do\s+not)\s+understand\b/.test(t) ||
        /\b(?:confused|not\s+helpful|useless|broken)\b/.test(t) ||
        /\b(?:this\s+(?:is\s+)?(?:wrong|bad)|answer\s+(?:is\s+)?wrong)\b/.test(
            t
        ) ||
        /\btalk\s+to\s+(?:a\s+)?(?:person|human|support|agent)\b/.test(t) ||
        /\bconnect\s+(?:me\s+)?(?:to\s+|with\s+)?support\b/.test(t)
    );
}
